import { useTranslation } from 'react-i18next'
import React from 'react'

interface UnitsProps {
  unitConfig: any
  selectedUnit: string
  activeWallet: any
  setActiveUnit: (e: React.MouseEvent, currency: string, unit: string) => void
  show: boolean
}

const Units: React.FC<UnitsProps> = ({ unitConfig, selectedUnit, activeWallet, setActiveUnit, show }) => {
  const { t } = useTranslation()

  if (!show) {
    return null
  }

  return (
    <div className="withdraw-units">
      <span className="label">{t('wallet.unit', 'Unit')}</span>
      <div className="unit-list">
        {Object.keys(unitConfig.units).map((key) => {
          const unit = unitConfig.units[key]
          if (unit.code === 'raw') return null
          return (
            <span
              onClick={(e) => setActiveUnit(e, activeWallet.currency, unit.code)}
              className={'wallet-unit' + (unit.code === selectedUnit ? ' selected' : '')}
              title={unit.name}
              key={'unit_' + unit.name}
            >
              {unit.code}
            </span>
          )
        })}
      </div>
    </div>
  )
}

export default Units
